import { domainProvider } from '@mathflat/shared/@common/domain/domainProvider'

const isLive = import.meta.env.VITE_VERCEL_ENV === 'production'
const isStaging = import.meta.env.VITE_VERCEL_ENV === 'staging'
const isDev = import.meta.env.VITE_VERCEL_ENV === 'development'
const isPreview = import.meta.env.VITE_VERCEL_ENV === 'preview'
const isSchool = import.meta.env.VITE_BRAND === 'schoolflat'
const localStrapiApiUrl = import.meta.env.DEV
  ? import.meta.env.VITE_LOCAL_STRAPI_API_URL
  : undefined
const isTestEnv = import.meta.env.DEV || isPreview
export const isRealEnv = isLive || isStaging || isDev

const currentPhase = import.meta.env.VITE_VERCEL_ENV
const cryptoKey = import.meta.env.VITE_CRYPTO_KEY

// ★ 베이직 학생앱의 #/logout 으로 redirect — staging 측 기존 로그아웃 동선 보존용.
//   Phase 1 (반대편 student.* 가 아직 베이직) 케이스에서 logout 시 fallback 으로 사용.
//   isTestEnv (local/preview) 에선 자기 origin 으로 — 베이직 URL 이 dev 에 없을 수 있어 안전 fallback.
const redirectToBasicStudentApp = () => {
  const basicStudentAppUrl = domainProvider.replaceMathFlatDomain(
    import.meta.env.VITE_VERCEL_BASIC_STUDENT_APP_URL,
  )
  const redirectUrl = isTestEnv ? window.location.origin : basicStudentAppUrl
  window.location.replace(redirectUrl + '#/logout')
}

export const envUtils = {
  isLive,
  isStaging,
  isDev,
  isTestEnv,
  isRealEnv,
  currentPhase,
  redirectToBasicStudentApp,
  isSchool,
  localStrapiApiUrl,
  cryptoKey,
}
